import { useState } from "react"
import { Card, CardContent, Typography, Box } from "@mui/material"
import { DateCalendar, PickersDay, PickersDayProps } from "@mui/x-date-pickers"
import { isSameDay } from "date-fns"
import { Dayjs } from "dayjs" // only needed if you're using dayjs adapter

const highlightedDates = [
  new Date(2024, 6, 10),
  new Date(2024, 6, 15),
  new Date(2024, 6, 22),
]

// ✅ Correct component to use in slots.day
const CustomDay: React.FC<PickersDayProps<Date>> = (props) => {
  const { day } = props
  const isHighlighted = highlightedDates.some((highlighted) =>
    isSameDay(day, highlighted)
  )

  return (
    <PickersDay
      {...props}
      sx={{
        backgroundColor: isHighlighted ? "#2A9D90" : undefined,
        color: isHighlighted ? "#fff" : undefined,
        borderRadius: "8px",
        "&:hover": {
          backgroundColor: isHighlighted ? "#21867d" : undefined,
        },
      }}
    />
  )
}
const textColor = "#0d2561";
const itextColor = "#707070";

export default function PropertyViewingsWidget() {
  const [date, setDate] = useState<Date | null>(new Date())

  return (
    <Card elevation={3} sx={{ borderRadius: 2 }}>
      <CardContent>
        <Typography variant="h6" sx={{ color: textColor, mb: 1 }}>
          Property Viewings
        </Typography>
        
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Calendar showing viewing dates.
        </Typography>

        <Box display="flex" justifyContent="center">
          <DateCalendar
            value={date}
            onChange={setDate}
            slots={{
              day: CustomDay, // ✅ uses correct component
            }}
          />
        </Box>
      </CardContent>
    </Card>
  )
}
